import { makeId } from "../makeId";

export const generatePageBreak = () => ({
  id: makeId(),
  format: "page_break",
});
